import React from 'react';

const Layers = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4L20 8.00004L12 12L4 8.00004L12 4Z"
      stroke="#757575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 12L12 16L4 12"
      stroke="#757575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 16L12 20L4 16"
      stroke="#757575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Layers;
